import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../selectors';
import CartActions from './cart';
import HelpActions from './help';
import OfferActions from './offer';
import OrderActions from './order';

class UiActions {
    static types = actionsFromList([
        'CLOSE_MODAL',
        'OPEN_MODAL',
        'SWITCH_ACCOUNT_MODAL_VIEW',
    ]);

    // sync --------------------------------------------------------------------

    static openModal = (modalName) => ({
        type: UiActions.types.OPEN_MODAL,
        payload: { modalName },
    });

    static closeModal = (modalName) => ({
        type: UiActions.types.CLOSE_MODAL,
        payload: { modalName },
    });

    static switchAccountModalPane = (pane) => ({
        type: UiActions.types.SWITCH_ACCOUNT_MODAL_VIEW,
        payload: { pane },
    });

    // async -------------------------------------------------------------------

    static openHelpModal = () => (dispatch, getState) => {
        const state = getState();

        if (selectors.help.getFaqs(state).length === 0) {
            dispatch(HelpActions.requestFaqs());
        }
        if (selectors.help.getContacts(state).length === 0) {
            dispatch(HelpActions.requestContacts());
        }
        dispatch(UiActions.openModal('help'));
    };

    static finishOrder = (history) => (dispatch) => {
        dispatch(CartActions.setItems());
        dispatch(OfferActions.requestOffers());
        dispatch(OfferActions.selectProduct(-1));
        dispatch(OrderActions.resetProgress());
        dispatch(UiActions.closeModal('checkout'));

        history.push('/order');
    };

    static finishExcelOrder = (history) => (dispatch) => {
        dispatch(CartActions.setItems());
        dispatch(OfferActions.requestOffers());
        dispatch(OrderActions.resetExcelProgress());
        dispatch(UiActions.closeModal('validation'));

        history.push('/order');
    };

    static closeCheckoutModal = () => (dispatch) => {
        dispatch(UiActions.closeModal('checkout'));
        dispatch(OrderActions.resetProgress());
    };

    static closeShoppingCartModal = () => (dispatch) => {
        dispatch(UiActions.closeModal('shoppingcart'));
        dispatch(OrderActions.resetProgress());
    };

    static closeValidationModal = () => (dispatch) => {
        dispatch(UiActions.closeModal('validation'));
    };

    static closeFailedValidationModal = () => (dispatch) => {
        dispatch(UiActions.closeModal('failedValidation'));
    };

    static closeHelpModal = () => (dispatch) => {
        dispatch(UiActions.closeModal('help'));
        dispatch(HelpActions.updateContactMessage(''));
        dispatch(HelpActions.updateContactSubjectIndex(0));
    };
}

export default UiActions;



// WEBPACK FOOTER //
// ./app/actions/ui.js